import(/* webpackMode: "eager" */ "/home/eratecsolution/htdocs/www.eratecsolution.com/app/main.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/eratecsolution/htdocs/www.eratecsolution.com/components/Aos.init.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/eratecsolution/htdocs/www.eratecsolution.com/components/GoToTop.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/eratecsolution/htdocs/www.eratecsolution.com/components/Navbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/eratecsolution/htdocs/www.eratecsolution.com/components/WhatsappButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/eratecsolution/htdocs/www.eratecsolution.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/eratecsolution/htdocs/www.eratecsolution.com/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/eratecsolution/htdocs/www.eratecsolution.com/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
